var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-main-inner" },
    [
      _c("div", { staticStyle: { width: "fit-content" } }, [
        _c(
          "div",
          { staticClass: "section" },
          [
            _c(
              "el-form",
              {
                ref: "basicForm",
                attrs: { inline: true, "label-position": "left" }
              },
              [
                _c(
                  "div",
                  { staticClass: "el-form-item-group" },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("SeaExport.MasterBusinessNo"),
                          "lable-width": "90px"
                        }
                      },
                      [
                        _c("el-input", {
                          staticClass: "jobNo-color",
                          attrs: { no: "1", disabled: true },
                          model: {
                            value: _vm.job.jobNo,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "jobNo", $$v)
                            },
                            expression: "job.jobNo"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("SeaExport.WarehouseNo"),
                          "lable-width": "60px"
                        }
                      },
                      [
                        _c("el-input", {
                          attrs: { no: "2", disabled: true },
                          model: {
                            value: _vm.job.warehouseNo,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "warehouseNo", $$v)
                            },
                            expression: "job.warehouseNo"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "MBL", "lable-width": "60px" } },
                      [
                        _c("el-input", {
                          attrs: {
                            no: "3",
                            disabled: _vm.readonly || _vm.isCrossTenantSEToSI
                          },
                          model: {
                            value: _vm.job.mbl,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "mbl", $$v)
                            },
                            expression: "job.mbl"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("SeaExport.CustomerReferenceNumber"),
                          "lable-width": "90px"
                        }
                      },
                      [
                        _c("cargo-input", {
                          attrs: {
                            no: "4",
                            disabled: _vm.readonly,
                            trim: true
                          },
                          model: {
                            value: _vm.job.customerRefNo,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "customerRefNo", $$v)
                            },
                            expression: "job.customerRefNo"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { "lable-width": "0px" } },
                      [
                        _c(
                          "el-checkbox",
                          {
                            attrs: { no: "5", disabled: _vm.readonly },
                            model: {
                              value: _vm.job.usCustomsClearance,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "usCustomsClearance", $$v)
                              },
                              expression: "job.usCustomsClearance"
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("queryJob.UsCustomsClearance"))
                            )
                          ]
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { "lable-width": "0px" } },
                      [
                        _c(
                          "el-checkbox",
                          {
                            attrs: { disabled: _vm.readonly },
                            model: {
                              value: _vm.job.insure,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "insure", $$v)
                              },
                              expression: "job.insure"
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("SeaExport.InsureInfo")) + " ")]
                        )
                      ],
                      1
                    ),
                    _vm.showTrucking
                      ? _c(
                          "el-checkbox",
                          {
                            attrs: { no: "6", disabled: _vm.readonly },
                            model: {
                              value: _vm.job.landTransportation,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "landTransportation", $$v)
                              },
                              expression: "job.landTransportation"
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("SeaExport.DeliveryToDoor")))]
                        )
                      : _vm._e(),
                    _c(
                      "el-checkbox",
                      {
                        attrs: { no: "6.5", disabled: _vm.readonly },
                        model: {
                          value: _vm.job.importManifest,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "importManifest", $$v)
                          },
                          expression: "job.importManifest"
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("SeaImport.ImportManifest")))]
                    )
                  ],
                  1
                )
              ]
            )
          ],
          1
        ),
        _c(
          "div",
          { staticStyle: { display: "flex" } },
          [
            _c(
              "el-form",
              {
                ref: "basicForm",
                staticStyle: { display: "flex" },
                attrs: {
                  "label-position": "right",
                  "label-width": _vm.isZh ? "135px" : "160px"
                }
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "center-first section form-column",
                    staticStyle: { width: "349px" }
                  },
                  [
                    _vm.isZY
                      ? [
                          _c(
                            "el-form-item",
                            [
                              _c(
                                "span",
                                {
                                  staticClass: "blue",
                                  attrs: { slot: "label" },
                                  slot: "label"
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("SeaExport.AllowSaleProduct"))
                                  )
                                ]
                              ),
                              _c("cargo-advance-select", {
                                attrs: {
                                  "select-type":
                                    _vm.selectTypeNames
                                      .basic_data_AllowSaleProduct,
                                  filterable: "",
                                  no: "allowSaleProduct",
                                  disabled: _vm.readonly,
                                  clearable: "",
                                  "data-filter-function": function(p) {
                                    return p.statusEnabled && p.seaImportEnabled
                                  },
                                  "default-value": _vm.job.saleProductCode || ""
                                },
                                on: {
                                  parentCallBack: function(p) {
                                    _vm.job.saleProductCode = p.value
                                  }
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            [
                              _c(
                                "span",
                                {
                                  staticClass: "blue",
                                  attrs: { slot: "label" },
                                  slot: "label"
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("SeaExport.FullOrInside"))
                                  )
                                ]
                              ),
                              _c("cargo-advance-select", {
                                attrs: {
                                  "select-type":
                                    _vm.selectTypeNames
                                      .local_cache_FullOrInside$FULL_OR_INSIDE,
                                  no: "fullOrInside",
                                  disabled: _vm.readonly,
                                  clearable: "",
                                  "default-value": _vm.job.fullOrInside || ""
                                },
                                on: {
                                  parentCallBack: function(p) {
                                    _vm.job.fullOrInside = p.value
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ]
                      : _vm._e(),
                    _c(
                      "el-form-item",
                      {
                        attrs: { label: _vm.$t("SeaExport.SolicitationType") }
                      },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: {
                              no: "7",
                              disabled: _vm.readonly,
                              placeholder: _vm.$t("SeaExport.PleaseSelect"),
                              size: "mini"
                            },
                            on: {
                              change: function(val) {
                                _vm.pm.cargoSourceChange(val)
                              }
                            },
                            model: {
                              value: _vm.job.cargoSource,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "cargoSource", $$v)
                              },
                              expression: "job.cargoSource"
                            }
                          },
                          _vm._l(_vm.CARGO_SOURCES, function(item, index) {
                            return _c("el-option", {
                              key: index,
                              attrs: {
                                label: _vm.isZh
                                  ? item.chineseName
                                  : item.englishName,
                                value: item.code
                              }
                            })
                          }),
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.CustomJobType") } },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "8",
                            filterable: "",
                            clearable: true,
                            disabled: _vm.readonly,
                            "select-type":
                              _vm.selectTypeNames.basic_data_CutomJobType,
                            "static-options": _vm.customJobTypeList,
                            "method-params": { type: _vm.job.lob },
                            "default-value": _vm.job.customJobType
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.job.customJobType = p.value
                              _vm.onCustomJobTypeChange(p)
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _vm.job.customJobType &&
                    _vm.secondaryCustomJobTypeList.length > 0
                      ? _c(
                          "el-form-item",
                          { attrs: { label: _vm.$t("CargoMsg.Cargo_Grade") } },
                          [
                            _c("cargo-advance-select", {
                              ref: "secondaryCustomJobType",
                              attrs: {
                                no: "secondaryCustomJobType",
                                disabled: _vm.readonly,
                                "select-type":
                                  _vm.selectTypeNames.basic_data_CutomJobType,
                                filterable: "",
                                cache: false,
                                "default-value": _vm.job.secondaryCustomJobType,
                                "tag-name": _vm.isZh ? "name" : "englishName",
                                "static-options": _vm.secondaryCustomJobTypeList
                              },
                              on: {
                                parentCallBack: function(p) {
                                  _vm.job.secondaryCustomJobType = p.value
                                }
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.OrderChannels") } },
                      [
                        _c("el-input", {
                          attrs: { no: "9", disabled: true },
                          model: {
                            value: _vm.job.salesChannel,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "salesChannel", $$v)
                            },
                            expression: "job.salesChannel"
                          }
                        })
                      ],
                      1
                    ),
                    _vm.isCrossTenantSEToSI
                      ? _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t(
                                "SeaExport.ConsignationRelationNumber"
                              )
                            }
                          },
                          [
                            _c("el-input", {
                              attrs: {
                                no: "10",
                                value: _vm.job.trustFromJob,
                                disabled: true
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.isCrossTenantSEToSI
                      ? _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t(
                                "SeaExport.BusinessCommissionedRelationNumber"
                              )
                            }
                          },
                          [
                            _c("el-input", {
                              attrs: {
                                no: "relatedJob",
                                value: _vm.job.relatedJob,
                                disabled: true
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.showChannelNo
                      ? _c(
                          "el-form-item",
                          { attrs: { label: _vm.$t("SeaExport.ChannelNo") } },
                          [
                            _c("el-input", {
                              attrs: {
                                no: "11",
                                value: _vm.job.channelNo,
                                disabled: true
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.visibleDesignationAgent
                      ? _c(
                          "el-form-item",
                          {
                            attrs: { label: _vm.$t("SeaExport.NominatedAgent") }
                          },
                          [
                            _c("cargo-company-select", {
                              attrs: {
                                no: "12",
                                disabled: !_vm.controllerEnable
                                  .txtDesignationAgent,
                                "method-params": {
                                  designationAgent: true,
                                  active: true
                                },
                                "default-value": _vm.job.designationAgent || "",
                                "tag-name": "englishName"
                              },
                              on: {
                                change: function(p) {
                                  _vm.pm.designationAgentChangeHandler(p)
                                }
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _c(
                      "el-form-item",
                      {
                        attrs: { label: _vm.$t("SeaExport.PortOfLoadingAgent") }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              display: "flex",
                              "align-items": "center"
                            }
                          },
                          [
                            _c(
                              "el-tooltip",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.sopImageB,
                                    expression: "sopImageB"
                                  }
                                ],
                                attrs: {
                                  no: "13",
                                  content: _vm.$t("SeaExport.SOPReceiver"),
                                  placement: "right-end"
                                }
                              },
                              [
                                _c("div", [
                                  _c("img", {
                                    staticStyle: {
                                      padding: "5px 0",
                                      cursor: "pointer"
                                    },
                                    attrs: {
                                      src: _vm.sopPic,
                                      width: "18",
                                      height: "28"
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.pm.sopChangeCustomerIdHandler()
                                      }
                                    }
                                  })
                                ])
                              ]
                            )
                          ],
                          1
                        ),
                        _c("cargo-company-select", {
                          attrs: {
                            no: "14",
                            disabled: _vm.readonly,
                            "method-params": {
                              overseaAgent: true,
                              active: true
                            },
                            "default-value": _vm.job.destinationAgent || "",
                            "tag-name": "englishName"
                          },
                          on: {
                            change: function(p) {
                              _vm.pm.txtDestinationAgentChangeHandler(p)
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.ShippingCompany") } },
                      [
                        _c("cargo-company-select", {
                          attrs: {
                            no: "15",
                            disabled:
                              !_vm.controllerEnable.txtCarrierId ||
                              _vm.isCrossTenantSEToSI,
                            "method-params": {
                              companyLob: "seaImport",
                              seaCmp: true,
                              active: true
                            },
                            "default-value": _vm.job.carrierId || ""
                          },
                          on: {
                            change: function(p) {
                              _vm.job.carrierId = p.value
                              _vm.onCarrierIdChange()
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _vm.bookingAgentVisible
                      ? _c(
                          "el-form-item",
                          {
                            attrs: { label: _vm.$t("SeaExport.BookingAgent") }
                          },
                          [
                            _c("cargo-company-select", {
                              attrs: {
                                no: "16",
                                disabled:
                                  !_vm.controllerEnable.txtBookingAgent ||
                                  _vm.isCrossTenantSEToSI,
                                "method-params": {
                                  bookingAgent: true,
                                  companyLob: "seaImport",
                                  active: true
                                },
                                "default-value": _vm.job.bookingAgent || ""
                              },
                              on: {
                                change: function(p) {
                                  _vm.job.bookingAgent = p.value
                                }
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _c(
                      "el-form-item",
                      {
                        attrs: { label: _vm.$t("SeaExport.BillExchangeAgent") }
                      },
                      [
                        _c("cargo-company-select", {
                          attrs: {
                            no: "100",
                            disabled: _vm.readonly,
                            "method-params": {
                              bookingAgent: true,
                              companyLob: "seaImport",
                              active: true
                            },
                            "default-value": _vm.job.exChangeAgent || ""
                          },
                          on: {
                            change: function(p) {
                              _vm.job.exChangeAgent = p.value
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.CustomsNo") } },
                      [
                        _c("el-input", {
                          attrs: { no: "17", disabled: _vm.readonly },
                          model: {
                            value: _vm.job.customsNo,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "customsNo", $$v)
                            },
                            expression: "job.customsNo"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.SoNo") } },
                      [
                        _c("so-no-input", {
                          attrs: { no: "18", disabled: _vm.readonly },
                          model: {
                            value: _vm.job.jobSoNo,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "jobSoNo", $$v)
                            },
                            expression: "job.jobSoNo"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("SeaExport.VesselOfChineseName")
                        }
                      },
                      [
                        _c("cargo-input", {
                          attrs: { no: "19", disabled: _vm.readonly },
                          model: {
                            value: _vm.job.vesselChineseName,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "vesselChineseName", $$v)
                            },
                            expression: "job.vesselChineseName"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.Vessel") } },
                      [
                        _c("cargo-input", {
                          attrs: {
                            no: "20",
                            disabled: _vm.readonly || _vm.isCrossTenantSEToSI,
                            "auto-uppercase": _vm.isUppercase
                          },
                          model: {
                            value: _vm.job.vessel,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "vessel", $$v)
                            },
                            expression: "job.vessel"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.Voyage") } },
                      [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              display: "flex",
                              "justify-content": "space-between"
                            }
                          },
                          [
                            _c("el-input", {
                              staticStyle: { flex: "1" },
                              attrs: {
                                no: "21",
                                disabled:
                                  _vm.readonly || _vm.isCrossTenantSEToSI,
                                "auto-uppercase": _vm.isUppercase
                              },
                              model: {
                                value: _vm.job.voyageFlight,
                                callback: function($$v) {
                                  _vm.$set(_vm.job, "voyageFlight", $$v)
                                },
                                expression: "job.voyageFlight"
                              }
                            }),
                            _c(
                              "el-checkbox",
                              {
                                staticStyle: { "margin-left": "5px" },
                                attrs: { no: "22", disabled: _vm.readonly },
                                model: {
                                  value: _vm.isTwoVessel,
                                  callback: function($$v) {
                                    _vm.isTwoVessel = $$v
                                  },
                                  expression: "isTwoVessel"
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("SeaExport.SecondCheck")))]
                            )
                          ],
                          1
                        )
                      ]
                    ),
                    _vm.isTwoVessel
                      ? _c(
                          "el-form-item",
                          {
                            attrs: { label: _vm.$t("SeaExport.SecondVessel") }
                          },
                          [
                            _c("cargo-input", {
                              attrs: {
                                no: "23",
                                disabled: _vm.readonly,
                                "auto-uppercase": _vm.isUppercase
                              },
                              model: {
                                value: _vm.job.secondVessel,
                                callback: function($$v) {
                                  _vm.$set(_vm.job, "secondVessel", $$v)
                                },
                                expression: "job.secondVessel"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.isTwoVessel
                      ? _c(
                          "el-form-item",
                          {
                            attrs: { label: _vm.$t("SeaExport.SecondVoyage") }
                          },
                          [
                            _c("cargo-input", {
                              attrs: {
                                no: "24",
                                disabled: _vm.readonly,
                                "auto-uppercase": _vm.isUppercase
                              },
                              model: {
                                value: _vm.job.secondVoyage,
                                callback: function($$v) {
                                  _vm.$set(_vm.job, "secondVoyage", $$v)
                                },
                                expression: "job.secondVoyage"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.PlaceOfReceipt") } },
                      [
                        _c("cargo-input", {
                          attrs: {
                            no: "25",
                            disabled: _vm.readonly || _vm.isCrossTenantSEToSI,
                            "auto-uppercase": _vm.isUppercase
                          },
                          model: {
                            value: _vm.job.dispatchingPlace,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "dispatchingPlace", $$v)
                            },
                            expression: "job.dispatchingPlace"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      [
                        _c(
                          "span",
                          {
                            staticClass: "blue",
                            attrs: { slot: "label" },
                            slot: "label"
                          },
                          [_vm._v(_vm._s(_vm.$t("SeaExport.PortOfLoading")))]
                        ),
                        _c("cargo-advance-select", {
                          ref: "loadingPortCode",
                          attrs: {
                            no: "26",
                            filterable: "",
                            disabled: _vm.readonly || _vm.isCrossTenantSEToSI,
                            placeholder: _vm.$t("SeaExport.RequiredItem"),
                            "select-type":
                              _vm.selectTypeNames.basic_data_Seaport,
                            "default-value": _vm.job.loadingPortCode,
                            "method-params": {}
                          },
                          on: { parentCallBack: _vm.loadingPortCodeChange }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      [
                        _c(
                          "span",
                          {
                            staticClass: "blue",
                            attrs: { slot: "label" },
                            slot: "label"
                          },
                          [_vm._v(_vm._s(_vm.$t("SeaExport.PortOfDischarge")))]
                        ),
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "27",
                            filterable: "",
                            disabled: _vm.readonly || _vm.isCrossTenantSEToSI,
                            placeholder: _vm.$t("SeaExport.RequiredItem"),
                            "callback-params": { key: "dischargingPortCode" },
                            "select-type":
                              _vm.selectTypeNames.basic_data_Seaport,
                            "default-value": _vm.job.dischargingPortCode,
                            "method-params": {}
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.job.dischargingPortCode = p.value
                              _vm.pm.dischargingPortCode_Change(p.value)
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      [
                        _c(
                          "span",
                          {
                            staticClass: "blue",
                            attrs: { slot: "label" },
                            slot: "label"
                          },
                          [_vm._v(_vm._s(_vm.$t("SeaExport.PlaceOfDelivery")))]
                        ),
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "destinationPortCode",
                            disabled: _vm.readonly,
                            "select-type":
                              _vm.selectTypeNames.basic_data_Seaport,
                            filterable: "",
                            "default-value": _vm.job.destinationPortCode,
                            placeholder: _vm.$t("SeaExport.RequiredItem")
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.job.destinationPortCode = p.value
                              _vm.pm.destinationPortCodeEasyChange(p)
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      [
                        _c(
                          "span",
                          { attrs: { slot: "label" }, slot: "label" },
                          [_vm._v(_vm._s(_vm.$t("SeaExport.FinalDestination")))]
                        ),
                        _c("cargo-input", {
                          attrs: {
                            no: "28",
                            disabled: _vm.readonly || _vm.isCrossTenantSEToSI
                          },
                          model: {
                            value: _vm.job.destinationPlace,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "destinationPlace", $$v)
                            },
                            expression: "job.destinationPlace"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.OperationDate") } },
                      [
                        _c("el-date-picker", {
                          staticStyle: { width: "100%" },
                          attrs: {
                            no: "29",
                            disabled: _vm.readonly,
                            clearable: "",
                            type: "date",
                            "value-format": "yyyy-MM-dd"
                          },
                          model: {
                            value: _vm.job.customsDate,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "customsDate", $$v)
                            },
                            expression: "job.customsDate"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.BookingDate") } },
                      [
                        _c("el-date-picker", {
                          staticStyle: { width: "100%" },
                          attrs: {
                            no: "30",
                            disabled: _vm.readonly,
                            type: "date",
                            clearable: "",
                            "value-format": "yyyy-MM-dd"
                          },
                          model: {
                            value: _vm.job.bookingDate,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "bookingDate", $$v)
                            },
                            expression: "job.bookingDate"
                          }
                        })
                      ],
                      1
                    ),
                    _c("el-form-item", [
                      _c(
                        "span",
                        {
                          staticClass: "blue",
                          attrs: { slot: "label" },
                          slot: "label"
                        },
                        [_vm._v(_vm._s(_vm.$t("SeaExport.DateOfDeparture2")))]
                      ),
                      _c(
                        "div",
                        { staticStyle: { display: "flex" } },
                        [
                          _c("el-date-picker", {
                            staticClass: "departure-date-picker",
                            staticStyle: { flex: "1", "margin-right": "5px" },
                            attrs: {
                              no: "31",
                              disabled:
                                !_vm.controllerEnable.dfETD ||
                                _vm.isCrossTenantSEToSI,
                              placeholder: _vm.$t("SeaExport.RequiredItem"),
                              type: "date",
                              "value-format": "yyyy-MM-dd",
                              clearable: ""
                            },
                            on: { input: _vm.etdChange },
                            model: {
                              value: _vm.job.etd,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "etd", $$v)
                              },
                              expression: "job.etd"
                            }
                          }),
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm._f("filterWeek")(_vm.job.sailingDay))
                            )
                          ])
                        ],
                        1
                      )
                    ]),
                    _c("el-form-item", [
                      _c(
                        "span",
                        {
                          staticClass: "blue",
                          attrs: { slot: "label" },
                          slot: "label"
                        },
                        [_vm._v(_vm._s(_vm.$t("SeaExport.DateOfArrival2")))]
                      ),
                      _c(
                        "div",
                        { staticStyle: { display: "flex" } },
                        [
                          _c("el-date-picker", {
                            staticStyle: { flex: "1", "margin-right": "5px" },
                            attrs: {
                              no: "32",
                              disabled: _vm.readonly,
                              placeholder: _vm.$t("SeaExport.RequiredItem"),
                              type: "date",
                              clearable: "",
                              "value-format": "yyyy-MM-dd"
                            },
                            on: { input: _vm.etaChange },
                            model: {
                              value: _vm.job.eta,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "eta", $$v)
                              },
                              expression: "job.eta"
                            }
                          }),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm._f("filterWeek")(_vm.job.etaSailingDay)
                              )
                            )
                          ])
                        ],
                        1
                      )
                    ]),
                    _c("el-form-item", [
                      _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                        _vm._v(
                          _vm._s(_vm.$t("SeaExport.ActualDateOfDeparture2"))
                        )
                      ]),
                      _c(
                        "div",
                        { staticStyle: { display: "flex" } },
                        [
                          _c("el-date-picker", {
                            staticStyle: { flex: "1", "margin-right": "5px" },
                            attrs: {
                              no: "33",
                              disabled: _vm.readonly,
                              type: "date",
                              "value-format": "yyyy-MM-dd"
                            },
                            on: { input: _vm.atdChange },
                            model: {
                              value: _vm.job.atd,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "atd", $$v)
                              },
                              expression: "job.atd"
                            }
                          }),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm._f("filterWeek")(_vm.job.atdSailingDay)
                              )
                            )
                          ])
                        ],
                        1
                      )
                    ]),
                    _c("el-form-item", [
                      _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                        _vm._v(_vm._s(_vm.$t("SeaExport.ActualDateOfArrival2")))
                      ]),
                      _c(
                        "div",
                        { staticStyle: { display: "flex" } },
                        [
                          _c("el-date-picker", {
                            staticStyle: { flex: "1", "margin-right": "5px" },
                            attrs: {
                              no: "34",
                              disabled: _vm.readonly,
                              type: "date",
                              clearable: "",
                              "value-format": "yyyy-MM-dd"
                            },
                            on: { input: _vm.ataChange },
                            model: {
                              value: _vm.job.ata,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "ata", $$v)
                              },
                              expression: "job.ata"
                            }
                          }),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm._f("filterWeek")(_vm.job.ataSailingDay)
                              )
                            )
                          ])
                        ],
                        1
                      )
                    ]),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.ArrivalTime2") } },
                      [
                        _c("el-date-picker", {
                          staticStyle: { width: "100%" },
                          attrs: {
                            no: "123",
                            disabled: _vm.readonly,
                            type: "date",
                            "value-format": "yyyy-MM-dd"
                          },
                          model: {
                            value: _vm.job.arrivalTime,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "arrivalTime", $$v)
                            },
                            expression: "job.arrivalTime"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.CustomsBroker") } },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "35",
                            disabled: _vm.readonly,
                            "select-type":
                              _vm.selectTypeNames.basic_data_Company,
                            "data-filter-function": _vm.customsBrokerFilter,
                            filterable: "",
                            "default-value": _vm.job.customsBroker || "",
                            "method-params": {
                              customsBroker: true,
                              companyLob: "seaImport",
                              active: true
                            }
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.pm.customsBrokerChangeHandler(p)
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("SeaExport.CustomsDeclarationMethod")
                        }
                      },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "customsMethod",
                            disabled: _vm.readonly,
                            "select-type":
                              _vm.selectTypeNames.basic_data_CustomsMode,
                            "method-params": { serviceType: 2 },
                            "tag-value": "serialNum",
                            filterable: "",
                            "default-value": _vm.job.customClaim
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.job.customClaim = p.value
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("SeaExport.CustomsDeclarationType")
                        }
                      },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "customsDeclarationType",
                            disabled: _vm.readonly,
                            "select-type":
                              _vm.selectTypeNames
                                .basic_data_CustomsDeclarationType,
                            filterable: "",
                            "default-value":
                              _vm.job.customsDeclarationType || "",
                            placeholder: _vm.$t("CargoMsg.Cargo_keyWordsTip")
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.job.customsDeclarationType = p.value
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.TradeMethod") } },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "36",
                            filterable: "",
                            disabled: _vm.readonly,
                            clearable: false,
                            "select-type":
                              _vm.selectTypeNames.basic_data_TradeTerm,
                            "method-params": {},
                            "callback-method-type": "value",
                            "default-value": _vm.job.tradeTerm + "",
                            "callback-params": { key: "tradeTerm" }
                          },
                          on: { parentCallBack: _vm.setJobSelectValue }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("SeaExport.ContractRateProperty")
                        }
                      },
                      [
                        _c(
                          "el-select",
                          {
                            ref: "bookingTerm",
                            attrs: {
                              no: "37",
                              disabled: _vm.readonly || _vm.isCrossTenantSEToSI,
                              placeholder: _vm.readonly
                                ? ""
                                : _vm.$t("SeaExport.PleaseSelect"),
                              clearable: false,
                              size: "mini"
                            },
                            model: {
                              value: _vm.job.bookingTerm,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "bookingTerm", $$v)
                              },
                              expression: "job.bookingTerm"
                            }
                          },
                          _vm._l(_vm.bookingTerms, function(item, index) {
                            return _c("el-option", {
                              key: index,
                              attrs: {
                                label: _vm.isZh
                                  ? item.chineseName
                                  : item.englishName,
                                value: item.code
                              }
                            })
                          }),
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("SeaExport.ShippingCompanyContractNo")
                        }
                      },
                      [
                        _c("el-input", {
                          attrs: { no: "38", disabled: _vm.readonly },
                          model: {
                            value: _vm.job.scNo,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "scNo", $$v)
                            },
                            expression: "job.scNo"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.FreeDemurrage") } },
                      [
                        _c("auto-number-input", {
                          attrs: {
                            no: "39",
                            precision: 0,
                            min: 0,
                            disabled: _vm.readonly
                          },
                          model: {
                            value: _vm.job.freeDemurrage,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "freeDemurrage", $$v)
                            },
                            expression: "job.freeDemurrage"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.FreeDetention") } },
                      [
                        _c("auto-number-input", {
                          attrs: {
                            no: "40",
                            precision: 0,
                            min: 0,
                            disabled: _vm.readonly
                          },
                          model: {
                            value: _vm.job.freeDetention,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "freeDetention", $$v)
                            },
                            expression: "job.freeDetention"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("Message.TerminalLocation") } },
                      [
                        _c("cargo-company-select", {
                          staticStyle: { width: "100%" },
                          attrs: {
                            no: "terminalCompany",
                            disabled: _vm.readonly,
                            "method-params": {
                              terminalCompany: true,
                              companyLob: "seaImport",
                              active: true
                            },
                            "default-value": _vm.job.terminalCompany || ""
                          },
                          on: {
                            change: function(p) {
                              _vm.JobUtils.terminalCompanyChangeHandler(
                                _vm.job,
                                p
                              )
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("Message.TerminalAddress") } },
                      [
                        _c("cargo-rich-textarea", {
                          staticStyle: { height: "110px" },
                          attrs: {
                            no: "deliveryAddress",
                            disabled: _vm.readonly
                          },
                          nativeOn: {
                            dblclick: function($event) {
                              _vm.showAdvanceTextDialog(
                                _vm.$t("Message.TerminalAddress"),
                                _vm.job.deliveryAddress,
                                function(val) {
                                  _vm.job.deliveryAddress = val
                                }
                              )
                            }
                          },
                          model: {
                            value: _vm.job.deliveryAddress,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "deliveryAddress", $$v)
                            },
                            expression: "job.deliveryAddress"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("CargoMsg.Cargo_TransportSource")
                        }
                      },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            filterable: "",
                            "select-type":
                              _vm.selectTypeNames.basic_data_TransportSource,
                            no: "transportSource",
                            "default-value": _vm.job.transportSource,
                            cache: false,
                            disabled: _vm.readonly,
                            "tag-value": "code",
                            placeholder: " "
                          },
                          on: {
                            parentCallBack: function(item) {
                              return (_vm.job.transportSource = item.value)
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("CargoMsg.Cargo_ServiceStatisticalArea")
                        }
                      },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            filterable: "",
                            "select-type":
                              _vm.selectTypeNames.basic_data_StatisticArea,
                            no: "statisticArea",
                            "default-value": _vm.job.statisticArea,
                            cache: false,
                            disabled: _vm.readonly,
                            "tag-value": "code",
                            placeholder: " "
                          },
                          on: {
                            parentCallBack: function(item) {
                              return (_vm.job.statisticArea = item.value)
                            }
                          }
                        })
                      ],
                      1
                    )
                  ],
                  2
                ),
                _c(
                  "div",
                  { staticClass: "center-two section form-column" },
                  [
                    _c("el-form-item", { attrs: { label: "" } }, [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "justify-content": "flex-end"
                          }
                        },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: {
                                no: "41",
                                type: "primary",
                                disabled: _vm.readonly
                              },
                              on: {
                                click: function($event) {
                                  return _vm.pm.onExcerption()
                                }
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("SeaExport.CopyFromOtherBill"))
                              )
                            ]
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: {
                                no: "42",
                                type: "primary",
                                disabled: _vm.readonly
                              },
                              on: {
                                click: function($event) {
                                  return _vm.pm.onCodeSearch()
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("SeaExport.CodeSearching")))]
                          )
                        ],
                        1
                      )
                    ]),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.Shipper") } },
                      [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              display: "flex",
                              "justify-content": "space-between"
                            }
                          },
                          [
                            _c("cargo-input", {
                              staticStyle: {
                                width: "80px",
                                "margin-right": "5px"
                              },
                              attrs: {
                                no: "43",
                                disabled: _vm.readonly,
                                placeholder: _vm.readonly
                                  ? ""
                                  : _vm.$t("SeaExport.Code2"),
                                "auto-uppercase":
                                  _vm.notUppercaseShipperConsigneNotify
                              },
                              model: {
                                value: _vm.job.shipperCode,
                                callback: function($$v) {
                                  _vm.$set(_vm.job, "shipperCode", $$v)
                                },
                                expression: "job.shipperCode"
                              }
                            }),
                            _c("cargo-company-select", {
                              staticStyle: {
                                flex: "1",
                                "margin-bottom": "10px"
                              },
                              attrs: {
                                no: "44",
                                disabled: _vm.readonly,
                                "method-params": {
                                  shipper: true,
                                  active: true
                                },
                                "default-value": _vm.job.shipperId || "",
                                "tag-name": "englishName"
                              },
                              on: {
                                change: function(data) {
                                  _vm.senderAndReceiverChange(
                                    "shipper",
                                    data,
                                    6,
                                    _vm.notUppercaseShipperConsigneNotify
                                  )
                                }
                              }
                            })
                          ],
                          1
                        ),
                        _c("cargo-input", {
                          attrs: {
                            no: "45",
                            disabled: _vm.readonly,
                            "auto-uppercase":
                              _vm.notUppercaseShipperConsigneNotify,
                            "use-read-only": true,
                            placeholder: _vm.readonly
                              ? ""
                              : _vm.$t(
                                  "SeaExport.BillsOfLadingDoubleClickEject"
                                )
                          },
                          nativeOn: {
                            dblclick: function($event) {
                              return _vm.showSenderAndReceiverDialog(
                                "shipper",
                                6,
                                false,
                                _vm.notUppercaseShipperConsigneNotify
                              )
                            }
                          },
                          model: {
                            value: _vm.job.shipperLine1,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "shipperLine1", $$v)
                            },
                            expression: "job.shipperLine1"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.Consignee") } },
                      [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              display: "flex",
                              "justify-content": "space-between"
                            }
                          },
                          [
                            _c("cargo-input", {
                              staticStyle: {
                                width: "80px",
                                "margin-right": "5px"
                              },
                              attrs: {
                                no: "46",
                                disabled: _vm.readonly,
                                placeholder: _vm.readonly
                                  ? ""
                                  : _vm.$t("SeaExport.Code2"),
                                "auto-uppercase":
                                  _vm.notUppercaseShipperConsigneNotify
                              },
                              on: {
                                change: function($event) {
                                  return _vm.pm.qConsigneeCode_focusOutHandler()
                                }
                              },
                              model: {
                                value: _vm.job.consigneeCode,
                                callback: function($$v) {
                                  _vm.$set(_vm.job, "consigneeCode", $$v)
                                },
                                expression: "job.consigneeCode"
                              }
                            }),
                            _c("cargo-company-select", {
                              staticStyle: {
                                flex: "1",
                                "margin-bottom": "10px"
                              },
                              attrs: {
                                no: "47",
                                disabled: _vm.readonly,
                                "method-params": {
                                  consignee: true,
                                  active: true
                                },
                                "default-value": _vm.job.consigneeId || "",
                                "tag-name": "englishName"
                              },
                              on: {
                                change: function(data) {
                                  _vm.senderAndReceiverChange(
                                    "consignee",
                                    data,
                                    6,
                                    true,
                                    _vm.notUppercaseShipperConsigneNotify
                                  )
                                }
                              }
                            })
                          ],
                          1
                        ),
                        _c("cargo-input", {
                          attrs: {
                            no: "48",
                            disabled: _vm.readonly,
                            "auto-uppercase":
                              _vm.notUppercaseShipperConsigneNotify,
                            "use-read-only": true,
                            placeholder: _vm.readonly
                              ? ""
                              : _vm.$t(
                                  "SeaExport.BillsOfLadingDoubleClickEject"
                                )
                          },
                          on: {
                            blur: function($event) {
                              return _vm.pm.qConsigneeAddr_focusOutHandler()
                            }
                          },
                          nativeOn: {
                            dblclick: function($event) {
                              return _vm.showSenderAndReceiverDialog(
                                "consignee",
                                6,
                                false,
                                _vm.notUppercaseShipperConsigneNotify
                              )
                            }
                          },
                          model: {
                            value: _vm.job.consigneeLine1,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "consigneeLine1", $$v)
                            },
                            expression: "job.consigneeLine1"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.NotifyParty") } },
                      [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              display: "flex",
                              "justify-content": "space-between"
                            }
                          },
                          [
                            _c("cargo-input", {
                              staticStyle: {
                                width: "80px",
                                "margin-right": "5px"
                              },
                              attrs: {
                                no: "49",
                                disabled: _vm.readonly,
                                placeholder: _vm.readonly
                                  ? ""
                                  : _vm.$t("SeaExport.Code2"),
                                "auto-uppercase":
                                  _vm.notUppercaseShipperConsigneNotify
                              },
                              model: {
                                value: _vm.job.notifyCode,
                                callback: function($$v) {
                                  _vm.$set(_vm.job, "notifyCode", $$v)
                                },
                                expression: "job.notifyCode"
                              }
                            }),
                            _c("cargo-company-select", {
                              staticStyle: {
                                flex: "1",
                                "margin-bottom": "10px"
                              },
                              attrs: {
                                no: "50",
                                disabled: _vm.readonly,
                                "method-params": { notify: true, active: true },
                                "default-value": _vm.job.notifyId || "",
                                "tag-name": "englishName"
                              },
                              on: {
                                change: function(data) {
                                  _vm.senderAndReceiverChange(
                                    "notify",
                                    data,
                                    6,
                                    _vm.notUppercaseShipperConsigneNotify
                                  )
                                }
                              }
                            })
                          ],
                          1
                        ),
                        _c("cargo-input", {
                          attrs: {
                            no: "51",
                            disabled: _vm.readonly,
                            "auto-uppercase":
                              _vm.notUppercaseShipperConsigneNotify,
                            placeholder: _vm.readonly
                              ? ""
                              : _vm.$t(
                                  "SeaExport.BillsOfLadingDoubleClickEject"
                                ),
                            "use-read-only": true
                          },
                          nativeOn: {
                            dblclick: function($event) {
                              return _vm.showSenderAndReceiverDialog(
                                "notify",
                                6,
                                false,
                                _vm.notUppercaseShipperConsigneNotify
                              )
                            }
                          },
                          model: {
                            value: _vm.job.notifyLine1,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "notifyLine1", $$v)
                            },
                            expression: "job.notifyLine1"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        staticClass: "auto-width",
                        attrs: { "label-width": "0" }
                      },
                      [
                        _c("booking-sea-eq-data-grid", {
                          attrs: {
                            value: _vm.seaEqList,
                            "container-load-type": _vm.job.containerLoadType,
                            "is-edit": _vm.isEdit,
                            job: _vm.job,
                            "hide-container-no": false
                          },
                          on: { eqQuantityChange: _vm.eqQuantityChangeHandler }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        staticStyle: { "margin-top": "10px" },
                        attrs: {
                          label: _vm.$t("SeaExport.EnglishDescriptionOfGoods")
                        }
                      },
                      [
                        _c("cargo-rich-textarea", {
                          staticStyle: { height: "110px" },
                          attrs: {
                            no: "52",
                            disabled: _vm.readonly || _vm.isCrossTenantSEToSI,
                            "text-chars": _vm.englishNameMaxChars,
                            "warning-count": _vm.englishNameWarningCount,
                            "auto-uppercase": _vm.isUppercaseByConfig
                          },
                          on: {
                            change: function($event) {
                              return _vm.pm.txtCargoEnglishNameChangeHandler()
                            }
                          },
                          nativeOn: {
                            dblclick: function($event) {
                              _vm.showAdvanceTextDialog(
                                _vm.$t("queryJob.englishDescriptionOfGoods"),
                                _vm.job.cargoEnglishName,
                                function(val) {
                                  _vm.job.cargoEnglishName = val
                                },
                                false,
                                null,
                                _vm.isUppercaseByConfig,
                                {
                                  warningCount: _vm.englishNameWarningCount,
                                  maxChar: _vm.englishNameMaxChars
                                }
                              )
                              _vm.focusAdvanceTextInput()
                            }
                          },
                          model: {
                            value: _vm.job.cargoEnglishName,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "cargoEnglishName", $$v)
                            },
                            expression: "job.cargoEnglishName"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("SeaExport.ChineseDescriptionOfGoods")
                        }
                      },
                      [
                        _c("cargo-rich-textarea", {
                          staticStyle: { height: "110px" },
                          attrs: {
                            no: "53",
                            disabled: _vm.readonly,
                            "text-chars": _vm.maxChars,
                            "warning-count": _vm.warningCount,
                            "auto-half-word": false
                          },
                          nativeOn: {
                            dblclick: function($event) {
                              _vm.showAdvanceTextDialog(
                                _vm.$t("SeaExport.ChineseDescriptionOfGoods"),
                                _vm.job.cargoChineseName,
                                function(val) {
                                  _vm.job.cargoChineseName = val
                                }
                              )
                              _vm.focusAdvanceTextInput()
                            }
                          },
                          model: {
                            value: _vm.job.cargoChineseName,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "cargoChineseName", $$v)
                            },
                            expression: "job.cargoChineseName"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.Marks") } },
                      [
                        _c("cargo-rich-textarea", {
                          staticStyle: { height: "110px" },
                          attrs: {
                            no: "54",
                            disabled: _vm.readonly || _vm.isCrossTenantSEToSI,
                            "text-chars": _vm.markMaxChars,
                            "warning-count": _vm.markWarningCount,
                            "auto-uppercase": _vm.isUppercaseByConfig
                          },
                          on: { change: _vm.onMarkChange },
                          nativeOn: {
                            dblclick: function($event) {
                              _vm.showAdvanceTextDialog(
                                _vm.$t("SeaExport.Marks"),
                                _vm.job.mark,
                                function(val) {
                                  _vm.job.mark = val
                                },
                                false,
                                null,
                                _vm.isUppercaseByConfig,
                                {
                                  warningCount: _vm.markWarningCount,
                                  maxChar: _vm.markMaxChars
                                }
                              )
                              _vm.focusAdvanceTextInput()
                            }
                          },
                          model: {
                            value: _vm.job.mark,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "mark", $$v)
                            },
                            expression: "job.mark"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.TradeTerms2") } },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "55",
                            filterable: "",
                            disabled: _vm.readonly || _vm.isCrossTenantSEToSI,
                            "select-type":
                              _vm.selectTypeNames.basic_data_IncoTerm,
                            "method-params": {},
                            "callback-method-type": "value",
                            "default-value": _vm.job.incoTerm + "",
                            "callback-params": { key: "incoTerm" }
                          },
                          on: { parentCallBack: _vm.setJobSelectValue }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.PreCollection") } },
                      [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              display: "flex",
                              "justify-content": "space-between"
                            }
                          },
                          [
                            _c("el-input-number", {
                              staticStyle: { "flex-grow": "1" },
                              attrs: {
                                no: "56",
                                value:
                                  _vm.job.depositReceived === 0
                                    ? undefined
                                    : _vm.job.depositReceived,
                                disabled: _vm.readonly,
                                controls: false,
                                precision: 3
                              },
                              on: {
                                input: function(val) {
                                  _vm.job.depositReceived = val
                                }
                              }
                            }),
                            _c("span", [_vm._v(_vm._s(_vm.localCurrency))])
                          ],
                          1
                        )
                      ]
                    )
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "center-three section form-column" },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.ActualQuantity") } },
                      [
                        _c("auto-number-input", {
                          attrs: {
                            no: "57",
                            precision: 0,
                            min: 0,
                            disabled: _vm.readonly || _vm.isCrossTenantSEToSI
                          },
                          on: {
                            change: function($event) {
                              return _vm.pm.quantityFocusInHandler()
                            }
                          },
                          model: {
                            value: _vm.job.quantityActual,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "quantityActual", $$v)
                            },
                            expression: "job.quantityActual"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.Package") } },
                      [
                        _c("cargo-packing-select", {
                          attrs: {
                            no: "58",
                            disabled: _vm.readonly || _vm.isCrossTenantSEToSI,
                            "default-value": _vm.job.packing
                          },
                          on: {
                            change: function(p) {
                              _vm.job.packing = p.value
                              _vm.pm.chargePacking()
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.ActualWeight") } },
                      [
                        _c(
                          "div",
                          { staticStyle: { display: "flex" } },
                          [
                            _c("auto-number-input", {
                              attrs: {
                                no: "59",
                                precision: 3,
                                min: 0,
                                disabled:
                                  _vm.readonly || _vm.isCrossTenantSEToSI
                              },
                              on: { change: _vm.weightContractChange },
                              model: {
                                value: _vm.job.weightActual,
                                callback: function($$v) {
                                  _vm.$set(_vm.job, "weightActual", $$v)
                                },
                                expression: "job.weightActual"
                              }
                            }),
                            _c("span", [_vm._v("KGS")])
                          ],
                          1
                        )
                      ]
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.ActualVolume") } },
                      [
                        _c(
                          "div",
                          { staticStyle: { display: "flex" } },
                          [
                            _c("auto-number-input", {
                              attrs: {
                                no: "60",
                                precision: 3,
                                min: 0,
                                disabled:
                                  _vm.readonly || _vm.isCrossTenantSEToSI
                              },
                              on: { change: _vm.cubageContractChange },
                              model: {
                                value: _vm.job.cubageActual,
                                callback: function($$v) {
                                  _vm.$set(_vm.job, "cubageActual", $$v)
                                },
                                expression: "job.cubageActual"
                              }
                            }),
                            _c("span", [_vm._v("CBM")])
                          ],
                          1
                        )
                      ]
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.ChargedWeightRT") } },
                      [
                        _c(
                          "div",
                          { staticStyle: { display: "flex" } },
                          [
                            _c("auto-number-input", {
                              attrs: {
                                no: "61",
                                precision: 3,
                                min: 0,
                                disabled:
                                  !_vm.controllerEnable.txtChargeWeight ||
                                  _vm.isCrossTenantSEToSI
                              },
                              on: {
                                change: function($event) {
                                  return _vm.pm.chargeWeightChangeHandler()
                                }
                              },
                              model: {
                                value: _vm.job.chargeWeight,
                                callback: function($$v) {
                                  _vm.$set(_vm.job, "chargeWeight", $$v)
                                },
                                expression: "job.chargeWeight"
                              }
                            }),
                            _c("span", [_vm._v("M/T")])
                          ],
                          1
                        )
                      ]
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.FLCLType") } },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "62",
                            filterable: "",
                            clearable: false,
                            disabled: _vm.readonly,
                            "select-type":
                              _vm.selectTypeNames
                                .local_cache_ImportConstants$_cargoTypeInputList,
                            "callback-method-type": "value",
                            "default-value": _vm.job.containerLoadType,
                            "tag-name":
                              _vm.$store.getters.language === "zh"
                                ? "chineseName"
                                : "englishName",
                            "tag-value": "code",
                            "callback-params": { key: "containerLoadType" }
                          },
                          on: {
                            parentCallBack: function(obj) {
                              return _vm.pm.qCargoType_Change(obj)
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("SeaExport.MBLTransportationClause")
                        }
                      },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "63",
                            filterable: "",
                            clearable: false,
                            disabled: _vm.readonly || _vm.isCrossTenantSEToSI,
                            "select-type":
                              _vm.selectTypeNames.basic_data_ShippingTerm,
                            "method-params": {},
                            "callback-method-type": "value",
                            "default-value": _vm.job.freightTermMBL + "",
                            "callback-params": { key: "freightTermMBL" }
                          },
                          on: { parentCallBack: _vm.setJobSelectValue }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: { label: _vm.$t("SeaExport.MblCargoReleaseWay") }
                      },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "64",
                            disabled: _vm.readonly,
                            clearable: false,
                            "select-type":
                              _vm.selectTypeNames
                                .local_cache_ImportConstants$_importReleaseTypes,
                            "callback-method-type": "value",
                            headers: [_vm.$t("Tool.Code")],
                            fields: ["code"],
                            "default-value": _vm.job.releaseTypeMbl,
                            "tag-name":
                              _vm.$store.getters.language === "zh"
                                ? "chineseName"
                                : "englishName",
                            "tag-value": "code",
                            "callback-params": { key: "releaseTypeMbl" }
                          },
                          on: { parentCallBack: _vm.setJobSelectValue }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("SeaExport.MasterBLFreightTerm")
                        }
                      },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "65",
                            filterable: "",
                            clearable: false,
                            disabled: _vm.readonly || _vm.isCrossTenantSEToSI,
                            "select-type":
                              _vm.selectTypeNames.basic_data_PaymentTerm,
                            "method-params": {},
                            "callback-method-type": "value",
                            "default-value": _vm.job.paymentTermMBL + "",
                            "callback-params": { key: "paymentTermMBL" }
                          },
                          on: { parentCallBack: _vm.setJobSelectValue }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.HarborDistrict") } },
                      [
                        _c("cargo-input", {
                          attrs: {
                            no: "66",
                            disabled: _vm.readonly,
                            "auto-uppercase": _vm.isUppercase
                          },
                          model: {
                            value: _vm.job.portDistrict,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "portDistrict", $$v)
                            },
                            expression: "job.portDistrict"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: { label: _vm.$t("SeaExport.BillExchangeDate") }
                      },
                      [
                        _c("el-date-picker", {
                          staticStyle: { width: "100%" },
                          attrs: {
                            no: "67",
                            disabled: _vm.readonly,
                            type: "date",
                            clearable: "",
                            "value-format": "yyyy-MM-dd"
                          },
                          on: {
                            change: function($event) {
                              return _vm.pm.dfCustDate_focusOutHandler()
                            }
                          },
                          model: {
                            value: _vm.job.transDate,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "transDate", $$v)
                            },
                            expression: "job.transDate"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.DateOfDelivery") } },
                      [
                        _c("el-date-picker", {
                          staticStyle: { width: "100%" },
                          attrs: {
                            no: "68",
                            disabled: _vm.readonly,
                            type: "date",
                            clearable: "",
                            "value-format": "yyyy-MM-dd"
                          },
                          model: {
                            value: _vm.job.deliverDate,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "deliverDate", $$v)
                            },
                            expression: "job.deliverDate"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("SeaExport.DateOfArrivalTheWarehouse")
                        }
                      },
                      [
                        _c("el-date-picker", {
                          staticStyle: { width: "100%" },
                          attrs: {
                            no: "69",
                            disabled: _vm.readonly,
                            type: "date",
                            clearable: "",
                            "value-format": "yyyy-MM-dd"
                          },
                          model: {
                            value: _vm.job.arriveStorageDate,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "arriveStorageDate", $$v)
                            },
                            expression: "job.arriveStorageDate"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.openWarehouse
                            ? _vm.$t("SeaExport.WarehouseSupplier")
                            : _vm.$t("SeaExport.Warehouse")
                        }
                      },
                      [
                        _c("cargo-company-select", {
                          ref: "warehouse",
                          attrs: {
                            no: "70",
                            disabled: _vm.readonly,
                            "select-type":
                              _vm.selectTypeNames.basic_data_Company,
                            "method-params": { warehouse: true, active: true },
                            "default-value": _vm.job.warehouseCmp || "",
                            "static-options": _vm.warehouseList
                          },
                          on: {
                            change: function(p) {
                              _vm.pm.warehouseCmpChangeHandler(p)
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _vm.openWarehouse
                      ? _c(
                          "el-form-item",
                          {
                            attrs: { label: _vm.$t("SeaExport.WareHouseName") }
                          },
                          [
                            _c(
                              "el-select",
                              {
                                attrs: {
                                  no: "warehouseName",
                                  disabled:
                                    _vm.readonly || !_vm.job.warehouseCmp,
                                  "allow-create": true,
                                  filterable: "",
                                  clearable: true
                                },
                                on: { change: _vm.warehouseNameChangeHandler },
                                model: {
                                  value: _vm.job.warehouseName,
                                  callback: function($$v) {
                                    _vm.$set(_vm.job, "warehouseName", $$v)
                                  },
                                  expression: "job.warehouseName"
                                }
                              },
                              _vm._l(_vm.warehouseNameList, function(
                                item,
                                index
                              ) {
                                return _c("el-option", {
                                  key: index,
                                  attrs: {
                                    label: item.warehouseName,
                                    value: item.warehouseName
                                  }
                                })
                              }),
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _c(
                      "el-form-item",
                      [
                        _c(
                          "span",
                          { attrs: { slot: "label" }, slot: "label" },
                          [_vm._v(_vm._s(_vm.$t("SeaExport.SalesCompany")))]
                        ),
                        _c("el-input", {
                          attrs: { no: "71", disabled: true },
                          model: {
                            value: _vm.txtSalesOffice,
                            callback: function($$v) {
                              _vm.txtSalesOffice = $$v
                            },
                            expression: "txtSalesOffice"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      [
                        _c(
                          "span",
                          {
                            staticClass: "blue",
                            attrs: { slot: "label" },
                            slot: "label"
                          },
                          [_vm._v(_vm._s(_vm.$t("SeaExport.Sales")))]
                        ),
                        _c("cargo-user-select", {
                          ref: "sales",
                          attrs: {
                            no: "72",
                            disabled: !_vm.saleEnabled,
                            "method-params": {
                              officeId: _vm.salesOfficeCheck
                                ? _vm.$store.getters.currentOfficeId
                                : "",
                              category: "role",
                              shape: "sales"
                            },
                            "default-value": _vm.job.sales || "",
                            "static-options": _vm.salesList,
                            placeholder: _vm.salesPrompt
                          },
                          on: {
                            change: function(p) {
                              _vm.pm.salesChangeHandler(p)
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.SalesOfGoods") } },
                      [
                        _c("cargo-user-select", {
                          attrs: {
                            no: "73",
                            disabled: _vm.readonly,
                            "method-params": {
                              category: "role",
                              shape: "salesOfGoods"
                            },
                            "default-value": _vm.job.cargoSalesId || ""
                          },
                          on: {
                            change: function(p) {
                              _vm.job.cargoSalesId = p.value
                              _vm.pm.cargoSalesChargeHandler(p)
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.SalesDepartment") } },
                      [
                        _c("cargo-department-new-select", {
                          attrs: {
                            no: "74",
                            disabled:
                              _vm.readonly ||
                              (_vm.isEdit &&
                                (_vm.job.sales === 0 || !_vm.job.sales)),
                            "sales-id": Number(_vm.job.sales),
                            enables: true,
                            "office-id": _vm.job.salesOffice,
                            "department-id": Number(_vm.job.salesDepartment)
                          },
                          on: {
                            change: function(p) {
                              _vm.job.salesDepartment = p.value
                              _vm.pm.departmentChargeHandler()
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: { label: _vm.$t("SeaExport.OperationCompany") }
                      },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "75",
                            filterable: "",
                            disabled: _vm.readonly || _vm.opOfficeDisabled,
                            "select-type":
                              _vm.selectTypeNames.basic_data_Office,
                            "default-value": _vm.job.opOffice,
                            "static-options": _vm.cacheOffices,
                            placeholder: ""
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.job.opOffice = p.value
                              _vm.job.opDepartment = 0
                              _vm.pm.opOfficeChangeHandler()
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      [
                        _c(
                          "span",
                          {
                            staticClass: "blue",
                            attrs: { slot: "label" },
                            slot: "label"
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("SeaExport.OperationDepartment"))
                            )
                          ]
                        ),
                        _c("cargo-department-select", {
                          ref: "department",
                          attrs: {
                            no: "76",
                            disabled: !_vm.saleEnabled,
                            enables: true,
                            "office-id": Number(_vm.job.opOffice),
                            "department-id": Number(_vm.job.opDepartment)
                          },
                          on: {
                            change: function(p) {
                              _vm.job.opDepartment = p.value
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.Operation") } },
                      [
                        _c("cargo-user-select", {
                          attrs: {
                            no: "77",
                            disabled: _vm.readonly,
                            "method-params": {
                              officeId: _vm.job.opOffice,
                              category: "role",
                              shape: "siop"
                            },
                            "default-value": _vm.job.op || "",
                            "static-options": _vm.userPortRoleData.op
                          },
                          on: {
                            change: function(p) {
                              _vm.job.op = p.value
                              _vm.pm.opChangeHandler(p)
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.CustomerOffice") } },
                      [
                        _c("cargo-office-select", {
                          attrs: {
                            no: "csrOffice",
                            disabled: true,
                            "office-id": Number(_vm.job.csrOffice)
                          },
                          on: {
                            change: function(p) {
                              _vm.job.csrOffice = p.value
                              _vm.job.csrDepartment = 0
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      [
                        _c(
                          "span",
                          { attrs: { slot: "label" }, slot: "label" },
                          [_vm._v(_vm._s(_vm.$t("Message.Customer_Service")))]
                        ),
                        _c("cargo-department-select", {
                          attrs: {
                            no: "csrDepartment",
                            "office-id": Number(_vm.job.csrOffice),
                            enables: true,
                            disabled: _vm.readonly,
                            "department-id": Number(_vm.job.csrDepartment)
                          },
                          on: {
                            change: function(p) {
                              _vm.job.csrDepartment = p.value
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.CustomerService") } },
                      [
                        _c("cargo-user-select", {
                          ref: "csr",
                          attrs: {
                            no: "78",
                            disabled: _vm.readonly,
                            "method-params": {
                              officeId:
                                _vm.pm.isEntrustOrder ||
                                _vm.job.salesOffice === 1
                                  ? _vm.job.opOffice
                                  : _vm.job.salesOffice,
                              category: "role",
                              shape: "csr"
                            },
                            "default-value": _vm.job.csr || "",
                            "static-options": _vm.userPortRoleData.csr
                          },
                          on: {
                            change: function(p) {
                              _vm.pm.csrChangeHandler(p)
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.FieldOperation") } },
                      [
                        _c("cargo-user-select", {
                          attrs: {
                            disabled: _vm.readonly,
                            "method-params": {
                              officeId: _vm.job.opOffice,
                              category: "role",
                              shape: "siteOp"
                            },
                            "default-value": _vm.job.siteOP || "",
                            "static-options": _vm.userPortRoleData.siteOp
                          },
                          on: {
                            change: function(p) {
                              _vm.JobUtils.siteOpChangeHandler(_vm.job, p)
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("SeaExport.OverseaCustomerService")
                        }
                      },
                      [
                        _c("cargo-user-select", {
                          ref: "overseaOp",
                          staticClass: "input2",
                          attrs: {
                            no: "overseaOp",
                            disabled: _vm.readonly,
                            "default-value": _vm.job.overseaOp || "",
                            "method-params": {
                              category: "role",
                              shape: "overseaOp"
                            },
                            "static-options": _vm.isHC
                              ? null
                              : _vm.userPortRoleData.overseaOp ||
                                _vm.overseaAgentUsersList,
                            "merge-load": true
                          },
                          on: {
                            change: function(p) {
                              _vm.job.overseaOp = p.value
                              _vm.OverseaCustomerUtils.overseaOpChangeHandler(
                                _vm.view,
                                p
                              )
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.DocumentOffice") } },
                      [
                        _c("cargo-office-select", {
                          attrs: {
                            no: "dcOffice",
                            disabled: true,
                            "office-id": Number(_vm.job.dcOffice)
                          },
                          on: {
                            change: function(p) {
                              _vm.job.dcOffice = p.value
                              _vm.job.dcDepartment = 0
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      [
                        _c(
                          "span",
                          { attrs: { slot: "label" }, slot: "label" },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("Message.Documentation_Department"))
                            )
                          ]
                        ),
                        _c("cargo-department-select", {
                          attrs: {
                            no: "dcDepartment",
                            "office-id": Number(_vm.job.dcOffice),
                            enables: true,
                            disabled: _vm.readonly,
                            "department-id": Number(_vm.job.dcDepartment)
                          },
                          on: {
                            change: function(p) {
                              _vm.job.dcDepartment = p.value
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.Documents") } },
                      [
                        _c("cargo-user-select", {
                          ref: "dc",
                          attrs: {
                            no: "79",
                            disabled: _vm.readonly,
                            "method-params": {
                              officeId: _vm.job.opOffice,
                              category: "role",
                              shape: "doc"
                            },
                            "default-value": _vm.job.dc || "",
                            "static-options": _vm.userPortRoleData.doc
                          },
                          on: {
                            change: function(p) {
                              _vm.pm.dcChangeHandler(p)
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isAddUserDefinedRoles,
                            expression: "isAddUserDefinedRoles"
                          }
                        ],
                        attrs: {
                          label: _vm.$t("CargoMsg.Cargo_userDefinedRole1")
                        }
                      },
                      [
                        _c("cargo-user-select", {
                          ref: "userDefinedRoleId1",
                          attrs: {
                            no: "userDefinedRoleId1",
                            disabled: _vm.readonly,
                            "method-params": {
                              officeId: _vm.$store.getters.currentOfficeId,
                              category: "role",
                              shape: "userDefinedRole1"
                            },
                            "default-value": _vm.job.userDefinedRoleId1 || "",
                            "merge-load": true,
                            "static-options":
                              _vm.userPortRoleData.userDefinedRole1
                          },
                          on: {
                            change: function(p) {
                              _vm.userDefinedRoleId1Handler(p)
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isAddUserDefinedRoles,
                            expression: "isAddUserDefinedRoles"
                          }
                        ],
                        attrs: {
                          label: _vm.$t("CargoMsg.Cargo_userDefinedRole2")
                        }
                      },
                      [
                        _c("cargo-user-select", {
                          ref: "userDefinedRoleId2",
                          attrs: {
                            no: "userDefinedRoleId2",
                            disabled: _vm.readonly,
                            "method-params": {
                              officeId: _vm.$store.getters.currentOfficeId,
                              category: "role",
                              shape: "userDefinedRole2"
                            },
                            "default-value": _vm.job.userDefinedRoleId2 || "",
                            "merge-load": true,
                            "static-options":
                              _vm.userPortRoleData.userDefinedRole2
                          },
                          on: {
                            change: function(p) {
                              _vm.userDefinedRoleId2Handler(p)
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.Remarks") } },
                      [
                        _c("cargo-rich-textarea", {
                          staticStyle: { height: "110px" },
                          attrs: {
                            no: "80",
                            disabled: _vm.readonly || _vm.isCrossTenantSEToSI,
                            "text-chars": _vm.maxChars,
                            "warning-count": _vm.warningCount,
                            "is-trim": true
                          },
                          nativeOn: {
                            dblclick: function($event) {
                              _vm.showAdvanceTextDialog(
                                _vm.$t("SeaExport.Remarks"),
                                _vm.job.remarks,
                                function(val) {
                                  _vm.job.remarks = val
                                }
                              )
                              _vm.focusAdvanceTextInput()
                            }
                          },
                          model: {
                            value: _vm.job.remarks,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "remarks", $$v)
                            },
                            expression: "job.remarks"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "center-four section form-column" },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: { label: _vm.$t("SeaExport.UserDefinedField1") }
                      },
                      [
                        _c("el-input", {
                          attrs: {
                            no: "81",
                            disabled: _vm.readonly,
                            type: "textarea",
                            rows: 5
                          },
                          nativeOn: {
                            dblclick: function($event) {
                              _vm.showAdvanceTextDialog(
                                _vm.$t("SeaExport.UserDefinedField1"),
                                _vm.job.userDefinedField1,
                                function(val) {
                                  _vm.job.userDefinedField1 = val
                                }
                              )
                            }
                          },
                          model: {
                            value: _vm.job.userDefinedField1,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "userDefinedField1", $$v)
                            },
                            expression: "job.userDefinedField1"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: { label: _vm.$t("SeaExport.UserDefinedField2") }
                      },
                      [
                        _c("el-input", {
                          attrs: {
                            no: "82",
                            type: "textarea",
                            rows: 5,
                            disabled: _vm.readonly
                          },
                          nativeOn: {
                            dblclick: function($event) {
                              _vm.showAdvanceTextDialog(
                                _vm.$t("SeaExport.UserDefinedField2"),
                                _vm.job.userDefinedField2,
                                function(val) {
                                  _vm.job.userDefinedField2 = val
                                }
                              )
                            }
                          },
                          model: {
                            value: _vm.job.userDefinedField2,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "userDefinedField2", $$v)
                            },
                            expression: "job.userDefinedField2"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: { label: _vm.$t("SeaExport.UserDefinedField3") }
                      },
                      [
                        _c("el-input", {
                          attrs: {
                            no: "83",
                            type: "textarea",
                            rows: 5,
                            disabled: _vm.readonly
                          },
                          nativeOn: {
                            dblclick: function($event) {
                              _vm.showAdvanceTextDialog(
                                _vm.$t("SeaExport.UserDefinedField3"),
                                _vm.job.userDefinedField3,
                                function(val) {
                                  _vm.job.userDefinedField3 = val
                                }
                              )
                            }
                          },
                          model: {
                            value: _vm.job.userDefinedField3,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "userDefinedField3", $$v)
                            },
                            expression: "job.userDefinedField3"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: { label: _vm.$t("SeaExport.UserDefinedField4") }
                      },
                      [
                        _c("el-input", {
                          attrs: {
                            no: "84",
                            type: "textarea",
                            rows: 5,
                            disabled: _vm.readonly
                          },
                          nativeOn: {
                            dblclick: function($event) {
                              _vm.showAdvanceTextDialog(
                                _vm.$t("SeaExport.UserDefinedField4"),
                                _vm.job.userDefinedField4,
                                function(val) {
                                  _vm.job.userDefinedField4 = val
                                }
                              )
                            }
                          },
                          model: {
                            value: _vm.job.userDefinedField4,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "userDefinedField4", $$v)
                            },
                            expression: "job.userDefinedField4"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.TaxNature") } },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: {
                              disabled: _vm.readonly,
                              no: "taxNature",
                              placeholder: _vm.$t("SeaExport.PleaseSelect"),
                              size: "mini"
                            },
                            model: {
                              value: _vm.job.taxNature,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "taxNature", $$v)
                              },
                              expression: "job.taxNature"
                            }
                          },
                          _vm._l(_vm.TAX_NATURES, function(item, index) {
                            return _c("el-option", {
                              key: index,
                              attrs: {
                                label: _vm.isZh
                                  ? item.chineseName
                                  : item.englishName,
                                value: item.code
                              }
                            })
                          }),
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            )
          ],
          1
        ),
        _c("div", { staticClass: "section" }, [
          _c("div", { staticClass: "form-row" }, [
            _c(
              "div",
              { staticClass: "title", staticStyle: { width: "100%" } },
              [
                _vm._v(" " + _vm._s(_vm.$t("SeaExport.TicketsInfo")) + " "),
                _c(
                  "div",
                  {
                    ref: "division",
                    staticClass: "division",
                    style: { height: _vm.divisionHeight + "px" },
                    on: {
                      mousedown: function($event) {
                        _vm.divisionEnabled = true
                      }
                    }
                  },
                  [
                    _c("div", {
                      staticClass: "line",
                      staticStyle: { "margin-top": "2px" }
                    }),
                    _c("div", { staticClass: "line" })
                  ]
                )
              ]
            ),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.readonly,
                    expression: "readonly"
                  }
                ],
                staticStyle: {
                  display: "flex",
                  "justify-content": "flex-start",
                  "margin-bottom": "5px",
                  "line-height": "28px"
                }
              },
              [
                _c("span", { staticStyle: { "margin-right": "5px" } }, [
                  _vm._v(_vm._s(_vm.$t("SeaExport.TotalTickets")) + ":")
                ]),
                _c("span", { staticStyle: { "margin-right": "5px" } }, [
                  _vm._v(_vm._s(_vm.job.lclSlaves.length))
                ]),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.viewSource === "bookingWorkspace",
                        expression: "viewSource === 'bookingWorkspace'"
                      }
                    ],
                    staticClass: "triggers"
                  },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: {
                          type: "primary",
                          no: "85",
                          disabled:
                            _vm.isEdit ||
                            _vm.viewSource === "financeDetail" ||
                            _vm.viewSource === "salesDetail"
                        },
                        on: {
                          click: function($event) {
                            return _vm.pm.btnCreate_clickHandler()
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("SeaExport.NewTickets")))]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: {
                          type: "primary",
                          no: "86",
                          disabled:
                            !_vm.selectedRow ||
                            _vm.viewSource === "financeDetail" ||
                            _vm.viewSource === "salesDetail"
                        },
                        on: {
                          click: function($event) {
                            return _vm.btnLcLEditClickHandler()
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("SeaExport.EditTickets")))]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: {
                          type: "primary",
                          no: "87",
                          disabled:
                            _vm.isEdit ||
                            _vm.viewSource === "financeDetail" ||
                            _vm.viewSource === "salesDetail"
                        },
                        on: {
                          click: function($event) {
                            return _vm.pm.btnAdd_clickHandler()
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("SeaExport.AddTickets")))]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: {
                          type: "danger",
                          no: "88",
                          disabled:
                            !_vm.selectedRow ||
                            _vm.viewSource === "financeDetail" ||
                            _vm.viewSource === "salesDetail"
                        },
                        on: {
                          click: function($event) {
                            return _vm.pm.btnRemove_clickHandler()
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("SeaExport.RemoveTickets")))]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: {
                          type: "primary",
                          no: "89",
                          disabled:
                            _vm.isEdit ||
                            _vm.viewSource === "financeDetail" ||
                            _vm.viewSource === "salesDetail"
                        },
                        on: {
                          click: function($event) {
                            return _vm.pm.onBatchPrint()
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("SeaExport.BatchPrint")))]
                    )
                  ],
                  1
                )
              ]
            ),
            _c(
              "div",
              {
                staticStyle: {
                  "min-height": "200px",
                  "flex-direction": "column"
                }
              },
              [
                _c(
                  "div",
                  {
                    ref: "slaveDiv",
                    staticStyle: { display: "flex", height: "300px" }
                  },
                  [
                    _c("cargo-ag-grid", {
                      attrs: {
                        "grid-options": _vm.gridOptions,
                        "column-defs": _vm.columnDefs,
                        "row-data": _vm.job.lclSlaves || []
                      },
                      on: {
                        gridReady: function(params) {
                          _vm.gridApi = params.api
                        }
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticStyle: {
                      display: "flex",
                      "justify-content": "flex-end"
                    }
                  },
                  [
                    _c("div", [
                      _vm._v(
                        _vm._s(_vm.$t("SeaExport.TotalNumberOfPackages")) +
                          "：" +
                          _vm._s(_vm.lbTotal.lblTotalQuantity) +
                          " "
                      )
                    ]),
                    _c("div", [
                      _vm._v(
                        _vm._s(_vm.$t("SeaExport.TotalWeight2")) +
                          "：" +
                          _vm._s(_vm.lbTotal.lblTotalWeight) +
                          " "
                      )
                    ]),
                    _c("div", [
                      _vm._v(
                        _vm._s(_vm.$t("SeaExport.TotalCubage")) +
                          "：" +
                          _vm._s(_vm.lbTotal.lblTotalCubage) +
                          " "
                      )
                    ])
                  ]
                )
              ]
            )
          ])
        ])
      ]),
      _vm.showContactsInfoDialog
        ? _c("cargo-contacts-info-dialog", {
            attrs: {
              visible: _vm.showContactsInfoDialog,
              "customer-id": _vm.job.customerId,
              "customer-contact": _vm.job.customerContact
            },
            on: {
              "update:visible": function($event) {
                _vm.showContactsInfoDialog = $event
              }
            }
          })
        : _vm._e(),
      _c("sop-dialog", {
        attrs: {
          visible: _vm.showSopDialog,
          "cmp-idx": _vm.sopDialog.cmpIdx,
          job: _vm.job,
          agent: _vm.sopDialog.agent,
          lob: "SI",
          "contact-list": _vm.sopDialog.contactList
        },
        on: {
          "update:visible": function($event) {
            _vm.showSopDialog = $event
          },
          updateJob: function($event) {
            return _vm.$emit("updateJob")
          }
        }
      }),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          ref: "advanceTextDialog",
          attrs: {
            no: "90",
            visible: _vm.advanceTextDialog.visible,
            title: _vm.advanceTextDialog.title,
            width: "600px",
            "close-on-click-modal": false,
            "close-on-press-escape": false
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.advanceTextDialog, "visible", $event)
            }
          }
        },
        [
          _c("cargo-rich-textarea", {
            staticStyle: { height: "320px" },
            attrs: {
              "text-chars": _vm.advanceTextDialog.formatObj.maxChar,
              "auto-uppercase": _vm.advanceTextDialog.isUppercase,
              "warning-count": _vm.advanceTextDialog.formatObj.warningCount,
              disabled: _vm.readonly
            },
            model: {
              value: _vm.advanceTextDialog.value,
              callback: function($$v) {
                _vm.$set(_vm.advanceTextDialog, "value", $$v)
              },
              expression: "advanceTextDialog.value"
            }
          }),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.readonly,
                      expression: "!readonly"
                    }
                  ],
                  attrs: { no: "xxx", type: "primary" },
                  on: { click: _vm.finishAdvanceText }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { no: "91" },
                  on: {
                    click: function($event) {
                      _vm.advanceTextDialog.visible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.close")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _c("import-prompt-title-dialog", {
        attrs: {
          visible: _vm.importPromptTitleDialog.visible,
          lob: _vm.job.lob
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.importPromptTitleDialog, "visible", $event)
          },
          selected: function(p) {
            _vm.pm.onExcerptionChangeFunc(p)
          }
        }
      }),
      _c("import-bill-address-title-dialog", {
        attrs: { visible: _vm.billAddressDialog.visible, job: _vm.job },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.billAddressDialog, "visible", $event)
          },
          callback: function(p) {
            _vm.pm.codeSearchCallback(p)
          }
        }
      }),
      _vm.templateSelectorDialog.visible
        ? _c("cargo-template-selector-dialog", {
            ref: "templateSelectorDialog",
            attrs: {
              visible: _vm.templateSelectorDialog.visible,
              ctx: _vm.templateSelectorDialog.ctx,
              category: _vm.templateSelectorDialog.category,
              data: _vm.templateSelectorDialog.data,
              context: _vm.context
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.templateSelectorDialog, "visible", $event)
              }
            }
          })
        : _vm._e(),
      _c("query-lcl-dialog", {
        attrs: { visible: _vm.queryLclDialog.visible, job: _vm.job },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.queryLclDialog, "visible", $event)
          },
          callback: function(rows) {
            _vm.pm.queryLclWindowReturnHandler(rows)
          }
        }
      }),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            no: "92",
            visible: _vm.ticketDialog.visible,
            title: _vm.$t("SeaExport.FillInQuantityOfVotes"),
            width: "270px",
            "close-on-click-modal": false,
            "close-on-press-escape": false
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.ticketDialog, "visible", $event)
            }
          }
        },
        [
          _c(
            "el-form",
            { attrs: { "label-width": "50px", "label-position": "right" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("SeaExport.Number") + "：" } },
                [
                  _c("el-input-number", {
                    attrs: { precision: 0, min: 1, max: 50, controls: false },
                    model: {
                      value: _vm.ticketDialog.value,
                      callback: function($$v) {
                        _vm.$set(_vm.ticketDialog, "value", $$v)
                      },
                      expression: "ticketDialog.value"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { no: "93", type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.pm.toAddTicket()
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { no: "94", type: "primary" },
                  on: {
                    click: function($event) {
                      _vm.ticketDialog.visible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }